/**
 * @generated SignedSource<<6e2f13a678e69584211c98a4eb955bc4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type AccountGroupPickerRefetchQuery$variables = {
  accountGroupFilterElement?: FilterElementInput | null | undefined;
  first?: number | null | undefined;
};
export type AccountGroupPickerRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AccountGroupPicker_accountGroups">;
};
export type AccountGroupPickerRefetchQuery = {
  response: AccountGroupPickerRefetchQuery$data;
  variables: AccountGroupPickerRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountGroupFilterElement"
  },
  {
    "defaultValue": 1000,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountGroupPickerRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "AccountGroupPicker_accountGroups"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AccountGroupPickerRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filterElement",
            "variableName": "accountGroupFilterElement"
          },
          (v1/*:: as any*/)
        ],
        "concreteType": "AccountGroupConnection",
        "kind": "LinkedField",
        "name": "accountGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountGroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountGroup",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "uuid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roleAssignmentTarget",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userPermissions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0e38b18abc97f0604bee32f84aaa50a1",
    "id": null,
    "metadata": {},
    "name": "AccountGroupPickerRefetchQuery",
    "operationKind": "query",
    "text": "query AccountGroupPickerRefetchQuery(\n  $accountGroupFilterElement: FilterElementInput\n  $first: Int = 1000\n) {\n  ...AccountGroupPicker_accountGroups_3ASum4\n}\n\nfragment AccountGroupPicker_accountGroups_3ASum4 on Query {\n  accountGroups(filterElement: $accountGroupFilterElement, first: $first) {\n    edges {\n      node {\n        name\n        uuid\n        roleAssignmentTarget\n        userPermissions\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0bd904d50800329426555497d3738b6";

export default node;
